import FrozenPlayer from "../images/얼어붙은플레이어의귀환.jpg";
import OmniscientReader from "../images/전지적독자시점.jpg";
import ExtraInFiction from "../images/소설속엑스트라.jpg";
import WhiteWolves from "../images/하얀늑대들.jpg";
import DragonRaja from "../images/드래곤라자.jpg";
import TutorialTower from "../images/튜토리얼탑의고인물.jpg";
import TheDruid from "../images/서울역드루이드.jpg";
import Genius from "../images/네크로맨서학교의소환천재.jpg";

export const ResultData = [
  {
    id: "frozenplayer",
    name: "얼어붙은 플레이어의 귀환",
    plot: "2024년, 지구가 게임처럼 변해 각종 몬스터가 출현한 지 5년 째 되던 날, 플레이어 서준호는 동료들과 함께 지구를 원래대로 되돌리기 위해 서리여왕을 잡으러 간다. \n 사투 끝에 서리영왕을 죽이는데 성공하지만 그녀의 핵이 서준호의 몸에 흡수되고, 결국 얼어붙게 되는데...! \n 시간이 지난 후 간신히 얼음에서 풀려난 그는 이번에는 자신처럼 얼어붙은 동료들을 되살리기 위해 움직인다.",
    //한줄로 작성해야 에러가 나지않음!
    image: `${FrozenPlayer}`,
    url1: "https://page.kakao.com/content/53366985",
  },

  {
    id: "omniscientreader",
    name: "전지적 독자 시점",
    plot: "멸망한 세계에서 살아남는 세 가지 방법, 줄여서 멸살법이 연재되는 10년 동안 유일한 독자였던 김독자. \n 멸살법이 끝난 후 작가로부터 에필로그와 함께 유료화 된다는 메일을 받는다. 그리고 유료화와 동시에 세상은 멸살법처럼 변해버린다.",
    image: `${OmniscientReader}`,
    url2: "https://series.naver.com/novel/detail.series?productNo=3400123",
  },
  {
    id: "novelextra",
    name: "소설 속 엑스트라",
    plot: "작가 김하진. \n 어느 날 애독자로부터 연중소설을 리메이크를 해도 괜찮겠냐는 메일을 받는다. \n 수락한 순간 그는 자신이 쓴 소설의 엑스트라에 빙의된다. \n 그 후 김하진은 아무도 쓰지 않는 무기 <총>과 작가로서 알고 있는 여러 정보를 이용해 살아남기, 그리고 세상을 구하기 위해 고군분투하는데...",
    image: `${ExtraInFiction}`,
    url1: "https://page.kakao.com/content/51752314",
    url2: "https://series.naver.com/novel/detail.series?productNo=3549008",
  },
  {
    id: "thewhitewolves",
    name: "하얀 늑대들",
    plot: "기사가 되기 위해 무작정 집을 나선 카셀. \n 멋진 기사를 꿈꿨지만 현실은 무력한 패잔병이다. \n 집으로 돌아가는 길, 카셀은 우연히 세계 최고의 기사 <하얀늑대> 소유의 보검을 줍게 된다. \n 카셀은 보검을 하얀 늑대에게 돌려주기 위해 모험을 떠나고, 그 과정에서 하얀 늑대의 신뢰를 얻어 그들의 리더가 된다. \n 하얀 늑대의 도움으로 간신히 고국의 내전을 끝냈지만, 더 큰 위험이 도사리고 있다는 걸 알게 되는데...!",
    image: `${WhiteWolves}`,
    url1: "https://page.kakao.com/content/47338515?orderby=desc",
    url2: "https://series.naver.com/novel/detail.series?productNo=1681385",
  },
  {
    id: "dragonraja",
    name: "드래곤 라자",
    plot: "주인공 후치는 오랜 기간 이무타드트라는 사악한 드래곤에게 시달려온 작은 영지에 살고 있다. \n 후치의 가족과 친구들은 이무타르트를 없애기 위해 토벌대를 꾸리지만 역으로 당해 이무타르트의 인질이 되버린다. 후치는 아버지를 포함한 마을 사람들의 몸값을 지불하기 위해 국왕을 만나러 가는 여행을 떠나고, 그 과정에서 엘프와 드워프, 도적, 미래의 대마법사, 폐태자와 친해진다. \n 과연 후치는 무사히 아버지와 마을 사람들을 풀어줄 수 있을까?",
    image: `${DragonRaja}`,
    url1: "https://page.kakao.com/content/46416207",
    url2: "https://series.naver.com/novel/detail.series?productNo=6369976",
  },
  {
    id: "theadvancedplayerofthetutorialtower",
    name: "튜토리얼 탑의 고인물",
    plot: "던전이라 불리는 차원의 문에서 각종 몬스터가 출현하는 세상. \n 튜토리얼 탑은 인간들을 <헌터>로 각성시켜 몬스터와 맞서게 하는 역할을 맡고 있다. \n 그 튜토리얼 탑에서 12년 동안 갇혀 있던 주인공 <김현우>는 마침내 지구로 귀환하고, 12년 동안 탑에 갇혀 수련만 했던 자신이 특별히 강하단 걸 알게 된다. \n 한편 <등반자>라는 세력이 지구를 멸망시키려 하고, 김현우는 자신이 그들을 막기 위한 가디언이라는 걸 알게 되는데...!",
    image: `${TutorialTower}`,
    url2: "https://series.naver.com/novel/detail.series?productNo=6369976",
  },
  {
    id: "seoulstationdruid",
    name: "서울역 드루이드",
    plot: "이계(異界)의 원시림에서 셀 수도 없이 긴 세월을 살아온 박수호. \n 마침내 차원의 문이 열리고 지구로 귀환한다. \n 하지만 지구 역시 각종 마물(魔物)이 날뛰는 위험한 세상이었고, 박수호는 자신이 이계에서 살면서 자연스럽게 체득한 드루이드 능력을 세계를 구하는 데 사용할 지 고민하는데...",
    image: `${TheDruid}`,
    url2: "https://series.naver.com/novel/detail.series?productNo=4059527",
  },
  {
    id: "necromanceracademythebestsummoner",
    name: "네크로멘서 학교의 소환천재",
    plot: "네크로맨서인 아버지와 프리스트인 어머니 사이에서 태어난 시몬. \n 세상의 절반은 네크로맨서가, 나머지 절반은 프리스트가 지배하는 상황 속에서 시몬의 영지는 네크로맨서와 프리스트가 공존하여 평화롭기만 하다. \n 어느 날 시몬은 모든 네크로맨서의 정점 <네프티스>로부터 네크로맨서 학교에 입학할 것을 권유받는데...!",
    image: `${Genius}`,
    url1: "https://page.kakao.com/content/55516007",
  },
];
